var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBg = function SvgBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1345 1294"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.808,
    cy: 1001.39,
    fill: "#DFFAD5",
    rx: 126.769,
    ry: 285.907,
    transform: "rotate(-45 291.808 1001.39)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 630.05,
    cy: 473.667,
    fill: "#DFFAD5",
    rx: 126.001,
    ry: 279.043,
    transform: "rotate(-45 630.05 473.667)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.787,
    cy: 782.655,
    fill: "#DFFAD5",
    rx: 127.433,
    ry: 299.352,
    transform: "rotate(-45 349.787 782.655)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.476,
    cy: 706.643,
    fill: "#DFFAD5",
    rx: 126.769,
    ry: 285.907,
    transform: "rotate(-45 576.476 706.643)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 966.919,
    cy: 520.521,
    fill: "#DFFAD5",
    rx: 126.769,
    ry: 285.907,
    transform: "rotate(-45 966.919 520.521)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1042.9,
    cy: 301.783,
    fill: "#DFFAD5",
    rx: 127.433,
    ry: 299.352,
    transform: "rotate(-45 1042.9 301.783)"
  })));
};
export default SvgBg;